import React, {useEffect} from 'react';

import * as d3 from 'd3';
import {useStore} from 'effector-react';
import {TFunction} from 'i18next';
import {Driver} from 'neo4j-driver';

import {useTranslation} from 'react-i18next';

import {isAdmin$, profile$} from 'models/auth';

import {OverrideTraceGraphConfig, TracingNodeStatement, TracingNode} from 'types';

import {build} from './build';

import './styles.css';

interface Props {
    data: TracingNode | null;
    statements: (t: TFunction) => TracingNodeStatement[];
    config?: OverrideTraceGraphConfig;
    period: [Date | null, Date | null];
}

// export const test: TracingNode = {
//     id: '844424930131976',
//     localId: '0',
//     inn: 'CF-928374061',
//     name: 'EQUATOR TECH GROUP',
//     clientId: '7',
//     gtin: '8005647003225',
//     isSold: false,
//     isDropout: false,
//     childrenCount: 1,
//     inputAmount: 4,
//     startAmount: 91,
//     outputAmount: 3,
//     dropoutAmount: 1,
//     sum: 1766.67,
//     soldAmount: 0,
//
//     parents: [
//         {
//             id: '844424930132007',
//             localId: '2',
//             inn: 'CF-546564755',
//             name: 'OUBANGUI DIST COM',
//             clientId: '9',
//             gtin: '8005647003225',
//             isSold: false,
//             isDropout: false,
//             childrenCount: 1,
//             inputAmount: 2,
//             startAmount: 91,
//             outputAmount: 2,
//             dropoutAmount: 1,
//             sum: 2120,
//             soldAmount: 0,
//             parents: [
//                 {
//                     id: '844424930132009',
//                     localId: '4',
//                     inn: 'CF-99058746',
//                     name: 'LLC TODAY IMP',
//                     clientId: '6',
//                     gtin: '8005647003225',
//                     isSold: false,
//                     isDropout: false,
//                     childrenCount: 1,
//                     inputAmount: 2,
//                     startAmount: 91,
//                     outputAmount: 2,
//                     dropoutAmount: 1,
//                     sum: 1060,
//                     soldAmount: 0,
//                     parents: [
//                         {
//                             id: '844424930131976',
//                             localId: '0',
//                             inn: 'CF-928374061',
//                             name: 'EQUATOR TECH GROUP',
//                             clientId: '7',
//                             gtin: '8005647003225',
//                             isSold: false,
//                             isDropout: false,
//                             childrenCount: 1,
//                             inputAmount: 4,
//                             startAmount: 91,
//                             outputAmount: 3,
//                             dropoutAmount: 1,
//                             sum: 1766.67,
//                             soldAmount: 0,
//                             parents: [],
//                             children: [],
//                         },
//                     ],
//                     children: [],
//                 },
//             ],
//             children: [],
//         },
//     ],
//
//     children: [
//         {
//             id: '844424930132009',
//             localId: '4',
//             inn: 'CF-99058746',
//             name: 'LLC TODAY IMP',
//             clientId: '6',
//             gtin: '8005647003225',
//             isSold: false,
//             isDropout: false,
//             childrenCount: 1,
//             inputAmount: 2,
//             startAmount: 91,
//             outputAmount: 2,
//             dropoutAmount: 1,
//             sum: 1060,
//             soldAmount: 0,
//
//             parents: [
//                 {
//                     id: '844424930131976',
//                     localId: '0',
//                     inn: 'CF-928374061',
//                     name: 'EQUATOR TECH GROUP',
//                     clientId: '7',
//                     gtin: '8005647003225',
//                     isSold: false,
//                     isDropout: false,
//                     childrenCount: 1,
//                     inputAmount: 4,
//                     startAmount: 91,
//                     outputAmount: 3,
//                     dropoutAmount: 1,
//                     sum: 1766.67,
//                     soldAmount: 0,
//                     parents: [],
//                     children: [],
//                 },
//             ],
//
//             children: [
//                 {
//                     id: '844424930132007',
//                     localId: '2',
//                     inn: 'CF-546564755',
//                     name: 'OUBANGUI DIST COM',
//                     clientId: '9',
//                     gtin: '8005647003225',
//                     isSold: false,
//                     isDropout: false,
//                     childrenCount: 1,
//                     inputAmount: 2,
//                     startAmount: 91,
//                     outputAmount: 2,
//                     dropoutAmount: 1,
//                     sum: 2120,
//                     soldAmount: 0,
//
//                     parents: [
//                         {
//                             id: '844424930132009',
//                             localId: '4',
//                             inn: 'CF-99058746',
//                             name: 'LLC TODAY IMP',
//                             clientId: '6',
//                             gtin: '8005647003225',
//                             isSold: false,
//                             isDropout: false,
//                             childrenCount: 1,
//                             inputAmount: 2,
//                             startAmount: 91,
//                             outputAmount: 2,
//                             dropoutAmount: 1,
//                             sum: 1060,
//                             soldAmount: 0,
//                             parents: [],
//                             children: [],
//                         },
//                     ],
//
//                     children: [
//                         {
//                             id: '844424930131976',
//                             localId: '0',
//                             inn: 'CF-928374061',
//                             name: 'EQUATOR TECH GROUP',
//                             clientId: '7',
//                             gtin: '8005647003225',
//                             isSold: false,
//                             isDropout: false,
//                             childrenCount: 1,
//                             inputAmount: 4,
//                             startAmount: 91,
//                             outputAmount: 3,
//                             dropoutAmount: 1,
//                             sum: 1766.67,
//                             soldAmount: 0,
//                             parents: [],
//                             children: [],
//                         },
//                     ],
//                 },
//             ],
//         },
//     ],
// };

export const TraceGraph = ({data, statements, config, period}: Props) => {
    const {t} = useTranslation();
    const profile = useStore(profile$);
    const isAdmin = useStore(isAdmin$);

    useEffect(() => {
        if (data !== null)
            build({
                data,
                statements: statements(t),
                overrideConfig: config || {},
                period,
                name: profile?.client?.fullName,
                clientId: profile?.client?.id,
                isAdmin,
            });
        return () => {
            d3.select('#trace-graph')
                .selectChildren('*')
                .remove();
            d3.selectAll('.tg-name-tip').remove();
        };
    }, [data, t]);

    return (
        <svg id="trace-graph">
            <g transform="translate(2, 2)">
                <defs id="defs" />
            </g>
        </svg>
    );
};
